import { useEffect, useState } from 'react'
import { Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import closeImage from 'assets/images/close.png'
import { SelectField, DateField } from 'components/Inputs/Inputs'
import { useGetConfigurationQuery, useGetRoomsTypesQuery } from 'redux/store/actions'
import { skipToken } from '@reduxjs/toolkit/dist/query'

export const HotelDetailsArr = (props: any) => {
  const [country, setCountry] = useState(null)
  const [city, setCity] = useState(null)
  const { data: Cities } = useGetConfigurationQuery(
    country ? `api/Configurations/countries/${country}/cities` : skipToken
  )

  const { data: HotelsByCity } = useGetConfigurationQuery(
    city ? `api/Packages/GetHotelsByCity/${city}` : skipToken
  )
  const [HotelId, setHotelId] = useState<any>([])
  const { data: rooomTypes } = useGetRoomsTypesQuery(HotelId || skipToken)

  const { t } = useTranslation()
  const [checkIn, setCheckIn] = useState(null)
  useEffect(() => {
    if (props.packageDataById && props.packageDataById.Items.packageHotels[props.index]) {
      setCountry(props.packageDataById.Items.packageHotels[props.index].CountryId)
      setCity(props.packageDataById.Items.packageHotels[props.index].CityId)
    }
  }, [props.packageDataById])
  return (
    <div>
      <div className="w-full flex flex-wrap p-1 relative pb-10">
        <button
          type="button"
          onClick={() => {
            const haveId = props.fields.value[props.index].Id
            const deletedId = props.fields.value[props.index]
            const deletedItem = { ...deletedId, IsDeleted: true }
            if (haveId) {
              props.setDeletedHotelItems((prev: any) => [...props.deletedHotelItems, deletedItem])
            }
            props.fields.remove(props.index)
          }}
          className="absolute rtl:left-2 rtl:right-auto ltr:right-2 bottom-1 bg-[#FCE5E5] right-2 text-red-600 text-lg w-8 h-8 text-center rounded-xl">
          <img src={closeImage} alt="close" className="m-auto" />
        </button>
        <div className="w-1/5 p-1">
          <Field
            label="Country"
            name={`${props.name}.CountryId`}
            render={SelectField}
            options={props.configration?.data?.Countries || []}
            valueField="Id"
            disabled={props.mode === 'view'}
            onChange={(value: any) => {
              setCountry(value)
            }}
            textField="Value"
          />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="City"
            name={`${props.name}.CityId`}
            render={SelectField}
            options={Cities?.data || []}
            onChange={(value: any) => {
              setCity(value)
            }}
            valueField="Id"
            textField="Value"
          />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="Hotel"
            name={`${props.name}.HotelId`}
            render={SelectField}
            options={(HotelsByCity && HotelsByCity) || []}
            valueField="Id"
            textField="Name"
            onChange={(value: any) => {
              setHotelId(value)
            }}
            disabled={props.mode === 'view'}
          />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="Room Type"
            name={`${props.name}.HotelRoomId`}
            render={SelectField}
            options={rooomTypes?.data || []}
            valueField="RoomId"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>
        <div className="w-1/5 flex">
          <div className="w-1/2 p-1">
            <Field
              label="Check-In"
              name={`${props.name}.CheckInDate`}
              render={DateField}
              min={props.startDate}
              max={props.endDate}
              onChange={(e: any) => {
                setCheckIn(e)
              }}
              disabled={props.mode === 'view'}
            />
          </div>
          <div className="w-1/2 p-1">
            <Field
              label="Check-Out"
              name={`${props.name}.CheckOutDate`}
              render={DateField}
              min={checkIn}
              max={props.endDate}
              disabled={props.mode === 'view'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
